import { DocPage, Section, Demo, SpecTable } from "../../components/DocChrome";

export function ImplementationPage() {
    return (
        <DocPage
            title="Developer Implementation"
            description="How panels consume the Workspace Design System."
        >
            <Section title="Install / wire">
                <Demo title="Tailwind">
                    <pre className="overflow-x-auto rounded-mz-md bg-neutral-ink p-4 text-xs text-gold-light">
                        {`import { maeizTailwindPreset } from "@maeiz/tokens/tailwind-preset";

export default {
  presets: [maeizTailwindPreset],
  content: ["./index.html", "./src/**/*.{ts,tsx}", "../../packages/ui/src/**/*.{ts,tsx}"],
};`}
                    </pre>
                </Demo>
                <Demo title="CSS">
                    <pre className="overflow-x-auto rounded-mz-md bg-neutral-ink p-4 text-xs text-gold-light">
                        {`@import "@maeiz/tokens/tokens.css";
@tailwind base;
@tailwind components;
@tailwind utilities;`}
                    </pre>
                </Demo>
                <Demo title="Components">
                    <pre className="overflow-x-auto rounded-mz-md bg-neutral-ink p-4 text-xs text-gold-light">
                        {`import { Button, Table, StatusBadge } from "@maeiz/ui";`}
                    </pre>
                </Demo>
            </Section>
            <Section title="Rules">
                <SpecTable
                    rows={[
                        ["Tokens", "No raw brand hex in new UI"],
                        ["Components", "Extend @maeiz/ui — don't fork in apps"],
                        ["Docs", "Document new shared components in this DS app"],
                        ["Landing", "Out of scope — do not import Workspace DS into landing"],
                    ]}
                />
            </Section>
        </DocPage>
    );
}
